import MuiMenuItem from '@mui/material/MenuItem';
import type { MenuItemProps } from './IMenuItem';
import { styles } from './styles';

const MenuItem = ({ sx, ...rest }: MenuItemProps) => (
    <MuiMenuItem
        sx={[styles.root, ...(Array.isArray(sx) ? sx : [sx])]}
        {...rest}
    />
);

export default MenuItem;
